<div class="input-group">
    <span class="input-group-text">$</span>
    <input
        type="text"
        [formControl]="amountControl"
        (blur)="onBlur()"
        mask="separator.2"
        thousandSeparator=","
        separatorLimit="9999999999"
        class="form-control"
        placeholder="0.00"
        [class.is-invalid]="hasErrors"
        [class.is-valid]="isValid" />
</div>
@if (hasErrors && touched && showValidationMessages()) {
    <div class="error-messages">
        @for (error of getErrors(); track $index) {
            <p class="text-danger text-start pt-1 mb-0">{{ error }}</p>
        }
    </div>
}
